import CardMarkerSuperLong from '../../../../../components/CockpitCards/CardMarkerSuperLong';
import PharmaGenesSubText from './PharmaGenesSubText';
import { DrugtypeTableData } from './GetDrugtypes';

export default function PharmaGenesCard() {


return(
<>

<CardMarkerSuperLong

  headline = "PGx Genes - Genotypes" 
  subtext = {<PharmaGenesSubText />}
  
  cardlines = {<> 

    <DrugtypeTableData />

   </>
  }
/>

</>
)
}

